export const GooglePayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" fill="#F2F2F2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0128 12.1614C19.0128 11.6674 18.9731 11.1735 18.8936 10.6896H12.1455V13.482H16.0115C15.8525 14.3793 15.3357 15.1857 14.5804 15.6898V17.5044H16.886C18.2377 16.2443 19.0128 14.3793 19.0128 12.1614Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1452 19.2587C14.0732 19.2587 15.7031 18.6135 16.8857 17.5046L14.58 15.69C13.9341 16.1335 13.1092 16.3856 12.1452 16.3856C10.2768 16.3856 8.6966 15.1053 8.13012 13.3915H5.75488V15.2666C6.96735 17.7163 9.44197 19.2587 12.1452 19.2587Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.13027 13.3913C7.83212 12.4941 7.83212 11.5162 8.13027 10.6089V8.7439H5.75503C4.7314 10.7904 4.7314 13.2098 5.75503 15.2563L8.13027 13.3913Z"
      fill="#FBBC04"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1452 7.61488C13.1688 7.59472 14.1527 7.98788 14.8881 8.70364L16.9354 6.62694C15.6335 5.39704 13.9241 4.72161 12.1452 4.74177C9.44197 4.74177 6.96735 6.29426 5.75488 8.74397L8.13012 10.6191C8.6966 8.89518 10.2768 7.61488 12.1452 7.61488Z"
      fill="#EA4335"
    />
  </svg>
);
